import { formRedirectInfo } from "@components/FormRedirectInfo/constants";

export const findObjectByRefererId = (array, targetRefererId) => {
  return array.find((obj) => obj.refererId === targetRefererId);
};

export const getServicePageReferrer = (urlParams) => {
  const servicePageReferer = urlParams?.get("servicePageReferer")
    ? urlParams?.get("servicePageReferer")
    : urlParams?.get("servicepagereferer")
      ? urlParams?.get("servicepagereferer")
      : "";

  return servicePageReferer;
};

export const getRedirectUrl = (pathName, urlParams) => {
  const servicePageReferer = getServicePageReferrer(urlParams);

  if (formRedirectInfo[pathName] && servicePageReferer !== "") {
    const redirectUrl =
      findObjectByRefererId(formRedirectInfo[pathName], servicePageReferer) !==
      null
        ? findObjectByRefererId(formRedirectInfo[pathName], servicePageReferer)[
            "redirectUrl"
          ]
        : null;

    return redirectUrl;
  } else {
    return null;
  }
};
